<template>
    <residencies-current @created="onCreated">
        <div slot-scope="{ data: residency }">
            <div class="border-b px-4 py-6 sm:px-6">
                <div class="flex flex-col-reverse md:flex-row">
                    <div class="flex-grow md:pr-6">
                        <h1 class="text-lg text-grey-darkest font-normal mb-3">
                            Welcome home!
                        </h1>

                        <with-variables :variables="{ residency }">
                            <p
                                slot-scope="{ residency: { tenancy: { property, property: { address, landlord } } } }"
                                class="mb-3"
                            >
                                Your landlord, <strong>{{ landlord.name }}</strong>,
                                has invited you to manage your tenancy at
                                <strong>{{ address.name }}</strong> on Rentora.
                            </p>
                        </with-variables>

                        <button
                            type="button"
                            class="text-blue text-sm rounded px-1 -ml-1 focus:outline-none focus:shadow-outline"
                            @click="show_info = !show_info"
                        >
                            <div class="flex items-center">
                                What is Rentora?

                                <base-svg
                                    :name="show_info ? 'icon-cheveron-up' : 'icon-cheveron-down'"
                                    :key="show_info ? 'icon-cheveron-up' : 'icon-cheveron-down'"
                                    class="fill-primary-blue w-5 h-5"
                                />
                            </div>
                        </button>
                    </div>
                    <div class="flex-none text-center mb-6 md:mb-0 md:mt-3">
                        <div class="mx-auto w-24">
                            <base-svg
                                slot="image"
                                name="illustration-home"
                                class="w-full"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="show_info"
                class="bg-grey-bg border-b px-4 py-6 sm:px-6"
            >
                <h1 class="text-lg text-grey-darkest font-normal mb-3">
                    Rentora, in a nutshell
                </h1>

                <p class="mb-3">
                    Rentora is a cloud-based platform for landlords and tenants to manage
                    their tenancies - anytime.
                </p>

                <p class="mb-3">
                    Pay your rent from your phone with a tap, securely share documents and more.
                </p>

                <laroute-link
                    :to="{ name: 'www.home.index' }"
                    class="flex items-center text-sm text-blue no-underline"
                >
                    Read more on our homepage
                    <base-svg
                        name="icon-cheveron-right"
                        class="fill-primary-blue w-5 h-5"
                    />
                </laroute-link>
            </div>

            <div class="border-b px-4 py-6 sm:px-6">
                <with-variables :variables="{ residency }">
                    <grid-layout slot-scope="{ residency: { tenancy, tenancy: { property, property: { landlord } } } }">
                        <grid-layout-item class="sm:w-1/2 mb-3 sm:mb-0">
                            <div class="text-grey-darker text-xs tracking-wide uppercase">Landlord</div>
                            <div class="text-sm text-grey-darkest mb-3">{{ landlord.name }}</div>

                            <div class="text-grey-darker text-xs tracking-wide uppercase">Property</div>
                            <div class="text-sm text-grey-darkest">
                                <base-address :address="property.address" />
                            </div>
                        </grid-layout-item>
                        <grid-layout-item class="sm:w-1/2">
                            <div class="text-grey-darker text-xs tracking-wide uppercase">Duration</div>
                            <div class="text-sm text-grey-darkest">
                                {{ tenancy.starts_at | moment('DD/MM/YYYY') }}
                                <template v-if="tenancy.ends_at"> - {{ tenancy.ends_at | moment('DD/MM/YYYY') }}</template>
                                <template v-else>+</template>
                            </div>
                            <div class="text-xs leading-none text-grey-darker mb-3">
                                {{ tenancy.duration }} months, {{ $_.upperFirst(tenancy.term) }}
                            </div>

                            <div class="text-grey-darker text-xs tracking-wide uppercase">Rent</div>
                            <div class="text-sm text-grey-darkest">
                                {{ tenancy.amount | money(0) }} / mo
                            </div>
                            <div class="text-xs leading-none text-grey-darker">
                                Collected in {{ tenancy.collection }}
                            </div>
                        </grid-layout-item>
                    </grid-layout>
                </with-variables>
            </div>

            <div class="bg-grey-bg text-right px-4 py-3 sm:px-6 rounded-b">
                <router-link
                    :to="{ name: 'residencies.users.create' }"
                    class="flex-none btn btn-blue w-full md:w-auto"
                >
                    Continue
                </router-link>
            </div>
        </div>
    </residencies-current>
</template>

<script>
    import local from '../../../store/local'
    import ResidenciesCurrent from '../../../components/residencies-current'

    export default {
        components: {
            ResidenciesCurrent
        },
        data () {
            return {
                show_info: false
            }
        },
        methods: {
            onCreated ({ data: { occupant } }) {
                if (!local.get('guest-email')) {
                    local.set('guest-email', occupant.email)
                }
            }
        }
    }
</script>
